import axios from "axios";
import Key from "../clientVariables.json";

export const validateFieldWithSchemaAndApi = async ({
    schema,
    field,
    value,
    apiValidate, // optional function to hit API
  }) => {
    try {
      // 1. Yup validation first
      await schema.validateAt(field, { [field]: value });
  
      // 2. Optional API check (e.g., email existence)
      if (apiValidate) {
        const apiError = await apiValidate(value);
        if (apiError) {
          return { valid: false, message: apiError };
        }
      }
  
      return { valid: true, message: "Valid Email" };
    } catch (err) {
      return { valid: false, message: err.message };
    }
  };

  export const validateReoonEmailVerification = async (email) => {
    const key = Key.reoon_api_key;
    const mode = "power";
  
    const url = `https://emailverifier.reoon.com/api/v1/verify?email=${encodeURIComponent(email)}&key=${key}&mode=${mode}`;
  
    try {
      const res = await axios.get(url);
  
      const data = res.data;

      if(data.has_inbox_full){
        return { valid: false, message: "This email address cannot receive mail. Your inbox is full." };
      }
  
      if (!data.is_valid_syntax) {
        return { valid: false, message: "Invalid email format." };
      }
  
      if (!data.mx_accepts_mail || !data.is_safe_to_send || data.status === "undeliverable") {
        return { valid: false, message: "Invalid email address." };
      }
  
      if (data.is_disposable) {
        return { valid: false, message: "Disposable email addresses are not allowed." };
      }
  
      return { valid: true, message: "Valid Email" }; // All checks passed ✅
    } catch (error) {
      console.error("Email validation error:", error.response?.data || error.message || error);
      return { valid: false, message: "Error validating email. Please try again." };
    }
  };


